'use strict';

var _jquery = require('./lib/jquery-3.3.1.min');

var _jquery2 = _interopRequireDefault(_jquery);

var _scroll = require('./util/scroll');

var _scroll2 = _interopRequireDefault(_scroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var top = {
    data: {
        leftCharacter: 'fangzhi, chuyang, ningyou',
        rightCharacter: 'jingyi, hxr, yunchen',
        normalCharacter: ['fangzhi', 'chuyang', 'yunchen', 'jingyi'],
        audio: ['fangzhi', 'chuyang', 'yunchen', 'jingyi', 'hxr', 'ningyou'],
        timerMotto: 0,
        bgMusicPlay: false
    },
    pcInit: function pcInit() {
        this.playBg();
        this.loadAudio();
        this.bindEvent();
    },
    mobileInit: function mobileInit() {
        (0, _jquery2["default"])('.arrow').click(function () {
            var targetHeight = (0, _jquery2["default"])('.top').height();
            var currentHeight = (0, _jquery2["default"])(window).scrollTop();
            (0, _scroll2["default"])(currentHeight, targetHeight);
        });
        this.bindEvent('mobile');
    },
    playBg: function playBg() {
        (0, _jquery2["default"])('.bg-wrapper').html('<audio class="bg-music"><source src="./media/background.mp3" type="audio/mpeg"></audio>');
        (0, _jquery2["default"])('.bg-music-control').removeClass('off').addClass('on');
        (0, _jquery2["default"])('.bg-music')[0].play();
        this.data.bgMusicPlay = true;
    },
    loadAudio: function loadAudio() {
        var html = '',
            iLength = this.data.audio.length;
        for (var i = 0; i < iLength; i++) {
            html += '\n           <audio class="audio-' + this.data.audio[i] + '"><source src="./media/' + this.data.audio[i] + '.wav" type="audio/mpeg"></audio>\n           ';
        }
        (0, _jquery2["default"])('.audio').html(html);
    },
    bindEvent: function bindEvent(device) {
        var _this = this;

        if (device !== 'mobile') {
            this.bindHover();
            this.bindMotto();
            this.controlMusic();
            this.bindClickEvent();
            this.watchResize();
        }

        (0, _jquery2["default"])('.j-play-video').click(function () {
            _this.popupVideo();
        });
        (0, _jquery2["default"])('.j-close-video').click(function () {
            _this.hideVideo();
        });
    },
    bindHover: function bindHover() {
        var _this2 = this;

        this.fixHover((0, _jquery2["default"])('.j-ningyou-hover'), (0, _jquery2["default"])('.j-character-top .ningyou'));
        this.fixHover((0, _jquery2["default"])('.j-hxr-hover'), (0, _jquery2["default"])('.j-character-top .hxr'));
        this.data.normalCharacter.forEach(function (item) {
            _this2.normalHover((0, _jquery2["default"])('.j-character-top .' + item));
        });
    },
    fixHover: function fixHover(selector, target) {
        selector.mouseenter(function () {
            target.addClass('hover');
        }).mouseleave(function () {
            target.removeClass('hover');
        });
    },
    normalHover: function normalHover(selector) {
        selector.mouseenter(function () {
            (0, _jquery2["default"])(this).addClass('hover');
        }).mouseleave(function () {
            (0, _jquery2["default"])(this).removeClass('hover');
        });
    },
    bindMotto: function bindMotto() {
        var that = this;
        (0, _jquery2["default"])(document).on('mouseenter', '.character .item', function () {
            var characterName = (0, _jquery2["default"])(this).attr('data-name');
            that.data.timerMotto = setTimeout(function () {
                (0, _jquery2["default"])('.motto').attr('class', 'motto ' + characterName);
                if (that.data.leftCharacter.indexOf(characterName) !== -1) {
                    (0, _jquery2["default"])('.top-bar-left').fadeIn();
                } else if (that.data.rightCharacter.indexOf(characterName) !== -1) {
                    (0, _jquery2["default"])('.top-bar-right').fadeIn();
                }
                that.playAudio(characterName);
            }, 500);
        }).on('mouseleave', '.character .item', function () {
            var characterName = (0, _jquery2["default"])(this).attr('data-name');
            (0, _jquery2["default"])('.top-bar').hide();
            (0, _jquery2["default"])('.motto').removeClass(characterName);
            clearTimeout(that.data.timerMotto);
            that.resetAudio(characterName);
        });
    },
    playAudio: function playAudio() {
        var characterName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (characterName) {
            (0, _jquery2["default"])('.audio-' + characterName)[0].play();
        }
    },
    resetAudio: function resetAudio() {
        var characterName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (characterName) {
            var $this = (0, _jquery2["default"])('.audio-' + characterName)[0];
            $this.pause();
            $this.currentTime = 0;
        }
    },
    controlMusic: function controlMusic() {
        var that = this;
        (0, _jquery2["default"])('.bg-music-control').click(function () {
            var $this = (0, _jquery2["default"])(this);
            if ($this.hasClass('off')) {
                $this.removeClass('off').addClass('on');
                (0, _jquery2["default"])('.bg-music')[0].play();
                that.data.bgMusicPlay = true;
            } else {
                $this.removeClass('on').addClass('off');
                (0, _jquery2["default"])('.bg-music')[0].pause();
                that.data.bgMusicPlay = false;
            }
        });
    },
    bindClickEvent: function bindClickEvent() {
        (0, _jquery2["default"])('.booking-btn').click(function () {
            var targetHeight = (0, _jquery2["default"])('.top').height();
            var currentHeight = (0, _jquery2["default"])(window).scrollTop();
            (0, _scroll2["default"])(currentHeight, targetHeight);
        });
        (0, _jquery2["default"])('.activity-btn').click(function () {
            var targetHeight = (0, _jquery2["default"])('.top').height() + (0, _jquery2["default"])('.booking').height();
            var currentHeight = (0, _jquery2["default"])(window).scrollTop();
            (0, _scroll2["default"])(currentHeight, targetHeight);
        });
    },
    popupVideo: function popupVideo() {
        (0, _jquery2["default"])('html, body').addClass('unscroll');
        var $videoPopup = (0, _jquery2["default"])('.video-popup');
        $videoPopup.height((0, _jquery2["default"])(window).height());
        $videoPopup.width((0, _jquery2["default"])(window).width());
        if (!window.isPhone) {
            (0, _jquery2["default"])('.bg-music-control').removeClass('on').addClass('off');
            (0, _jquery2["default"])('.bg-music')[0].pause();
        }
        (0, _jquery2["default"])('.video-iframe').html('<iframe width="100%" height="100%" src="https://www.youtube.com/embed/a3ExFrwopKs" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
        $videoPopup.fadeIn();
    },
    hideVideo: function hideVideo() {
        (0, _jquery2["default"])('html, body').removeClass('unscroll');
        (0, _jquery2["default"])('.video-popup').fadeOut();
        (0, _jquery2["default"])('.video-iframe').html('');
        if (this.data.bgMusicPlay) {
            (0, _jquery2["default"])('.bg-music-control').removeClass('off').addClass('on');
            (0, _jquery2["default"])('.bg-music')[0].play();
        }
    },
    watchResize: function watchResize() {
        window.addEventListener('resize', function () {
            var $videoPopup = (0, _jquery2["default"])('.video-popup');
            $videoPopup.height((0, _jquery2["default"])(window).height());
            $videoPopup.width((0, _jquery2["default"])(window).width());
        });
    }
};
module.exports = top;


//////////////////
// WEBPACK FOOTER
// ./src/bsjyy/js/top.js
// module id = 101
// module chunks = 7 8